




























































import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import MainTextSection from "@/components/home-view/main-text-section/MainTextSection.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "Platform",
  components: {
    HeaderImg,
    MainTextSection
  },
  data() {
    return {
      sections: {
        platformMain: "platform-main",
        platformImg: "platform-img",
        platformFigcapture: "platform-figcapture"
      },
      platformMainContent1: [
        "Drug Farm's IDInVivo⁺ technology uses piggyBac transposon mutagenesis to generate a library of genetic mutations in mice. Mice with mutated individual genes are then analyzed to identify drug targets connected to host immunity. Potential drug targets are then validated in Drug Farm's laboratories using in vivo genetics and in vitro biochemistry and cell biology. "
      ],
      platformMainContent2: [
        "Drug Farm's MedChem5 is a proprietary integrated AI platform utilizes multiple novel neural networks including supervised learning, active learning and reinforcement learning to enable speedy medicinal chemistry development. "
      ],
      platformHeaderImg: {
        path: "platform",
        image: "",
        imageAlt: "platform top img"
      }
    };
  },
  created() {
    this.platformHeaderContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();

    window.addEventListener("resize", () => this.platformHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => this.platformHeaderContent());
  },
  methods: {
    setRevealAnimation() {
      Object.entries(this.sections).forEach((section: string[]) => {
        ScrollReveal().reveal(`.${section[1]}`, scrollConfig);
      });
    },
    platformHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.platformHeaderImg = {
        ...this.platformHeaderImg,
        image: desktopViewport
          ? "desktop_platform_top_img.jpg"
          : "mobile_platform_top_img.png"
      };
    }
  }
});
